import { AccountSwitchFragment } from '@playbooks/components/account/account-switch-fragment';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

const AccountDropSelect = ({ session, workspace, onCreate = undefined, onPrev, onSelect }) => {
	// Render
	return (
		<div className='flex-column min-h-96'>
			<div className='flex-start shrink-0 gap-2 border-b border-border px-2 py-1.5'>
				<Button data-menu-contained variant='ghost' size='icon-xs' aria-label='back' onClick={onPrev}>
					<Icon data-icon='inline-start' type='far' icon='chevron-left' aria-hidden />
				</Button>
				<h2 className='type-label'>Workspaces</h2>
			</div>
			<AccountSwitchFragment
				session={session}
				workspace={workspace}
				onCreate={onCreate}
				onSelect={onSelect}
				className='grow'
			/>
		</div>
	);
};
export { AccountDropSelect };
